<template>
  <div>
    <DataTableAG
      :columns="columns"
      :getcontentpath="getnotificationspath"
      jsonobject="notifications"
      :buttonList="['Muokkaa']"
      v-on:pressed-button1="editNotification"
      width="1200px"
      height="750px"
      archivecontentpath="2.0/newbe/deletenotifications"
      archiveparam="notificationids"
    />
  </div>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
export default {
  name: "Notifications",
  components: {
    DataTableAG,
  },
  methods: {
    editNotification(rowData) {
        this.$router.push("/addimmediatenotification/" + rowData.id);
    },
  },
  data: () => ({
    getnotificationspath: "/1.0/front/notifications",
    archivenotificationpath: "/1.0/newbe/archivenotification",
    columns: [
      {
        field: "title",
        headerName: "Otsikko",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "deleted",
        headerName: "Poistettu",
        width: 125,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "due",
        headerName: "Lähetyshetki",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "radius",
        headerName: "Ilmoituksen säde kilometreinä",
        width: 250,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "count",
        headerName: "Nähty",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "latitude",
        headerName: "Leveysaste",
        width: 125,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "longitude",
        headerName: "Pituusaste",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>
